import AttributeItem from "./AttributeItem";

export default function AttributeList({
  attributeProductList,
  deactivatePropertyFunc,
}) {
  return (
    <div className=" p-1 d-flex flex-wrap attribute-list">
      {attributeProductList?.map((value) => (
        <div className="att-item-container">
          <AttributeItem
            data={value}
            deactivatePropertyFunc={deactivatePropertyFunc}
          />
        </div>
      ))}
    </div>
  );
}
